export function SessionEndSuccessPage(): JSX.Element {
  return (
    <div>
      <h1>SessionEndSuccessPage</h1>
    </div>
  );
}
